import { render, staticRenderFns } from "./BookingAudienceSummaryPanelTable.vue?vue&type=template&id=59604d74&scoped=true&"
import script from "./BookingAudienceSummaryPanelTable.vue?vue&type=script&lang=js&"
export * from "./BookingAudienceSummaryPanelTable.vue?vue&type=script&lang=js&"
import style0 from "./BookingAudienceSummaryPanelTable.vue?vue&type=style&index=0&id=59604d74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59604d74",
  null
  
)

export default component.exports